import React from "react";
import FullStory, { FullStoryAPI } from "react-fullstory";

import { useFormatName } from "src/common/hooks/useFormatName";
import { useAuthState, User } from "src/features/auth";

export const FullStoryProvider: React.FunctionComponent = () => {
	const { user } = useAuthState();
	return user === null || user.fullstoryOrgId === "" ? null : (
		<Content user={user} />
	);
};

interface ContentProps {
	user: User;
}

const Content: React.FunctionComponent<ContentProps> = ({ user }) => {
	const formatName = useFormatName();
	React.useEffect(() => {
		FullStoryAPI("identify", user.id, { displayName: formatName(user) });
	}, [formatName, user]);
	return <FullStory org={user.fullstoryOrgId} />;
};
